<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M6.04 9.77v5.6l4.44.64V8.29l-4.44.64v.84ZM2 10.18v3.93c0 .42.3.77.72.83l1.32.2V9.16l-1.32.2c-.41.05-.72.4-.72.82ZM22.55 11.74l-4.07-7.31a.82.82 0 0 0-.93-.4.83.83 0 0 0-.63.8v2.59l-4.44.63v8.2l4.44.63v2.58a.84.84 0 0 0 .83.83c.3 0 .58-.16.73-.42l4.07-7.32a.82.82 0 0 0 0-.8Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
